import './_VisuallyHidden-5c0a2499.css';

var classes = {"InternalVisuallyHidden":"prc-src-InternalVisuallyHidden-nlR9R"};

export { classes as default };
